import { axiosInstance } from '@/shared/api/axios';
import {
  PdfDeleteRequestType,
  PdfExtractionRequestType,
  PdfExtractionResponseType,
  PdfListRequestType,
  PdfListResponseType,
  PdfUploadRequestType,
  PdfUploadResponseType,
} from '@/shared/types/api/registry/api.pdf';

const mapFile = (file: { fileId: number; fileName: string; key: string }) => ({
  fileId: file.fileId,
  fileName: file.fileName,
  key: file.key,
});

export const uploadPdf = async ({
  files,
  groupId,
  executeType,
  launchType,
}: PdfUploadRequestType): Promise<PdfUploadResponseType> => {
  const formData = new FormData();
  files.forEach((file) => {
    formData.append('files', file);
  });
  formData.append('groupId', groupId.toString());
  formData.append('executeType', executeType.toString());
  formData.append('launchType', launchType.toString());

  const { data } = await axiosInstance.post<{
    uploadedFiles: { fileId: number; fileName: string; key: string }[];
  }>('/pdf/files/', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return {
    uploadedFiles: data.uploadedFiles.map(mapFile),
  };
};

export const deleteUploadedPdf = async ({
  groupId,
  fileIds,
}: PdfDeleteRequestType): Promise<void> => {
  await axiosInstance.delete('/pdf/files/', {
    data: {
      groupId,
      fileIds,
    },
  });
};

export const getPdfFiles = async ({
  groupId,
  executeType,
  launchType,
}: PdfListRequestType): Promise<PdfListResponseType> => {
  const { data } = await axiosInstance.get<{
    files: { fileId: number; fileName: string; key: string }[];
  }>('/pdf/files/', {
    params: {
      groupId,
      executeType,
      launchType,
    },
  });

  return {
    files: data.files.map(mapFile),
  };
};

export const postPdfFilesExtraction = async ({
  groupId,
  fileIds,
  executeType,
  launchType,
}: PdfExtractionRequestType): Promise<PdfExtractionResponseType[]> => {
  const { data } = await axiosInstance.post<PdfExtractionResponseType[]>('/pdf/files/extraction/', {
    groupId,
    fileIds,
    executeType,
    launchType,
  });

  return data;
};
